import React, { useState } from "react";
import { EBButtonV2 } from "../components/common/EBButtonV2";
import { ArrowIcon } from "../icon/Arrow.Icon";
import "./Sidebar.Layout.css";

interface SidebarLayoutVerticalProps {
  verticalHeightToMinusPx: string;
}

interface SidebarLayoutProps {
  sidebar: React.ReactNode;
  mainContent: React.ReactNode;

  verticalProps?: SidebarLayoutVerticalProps;
}

export function SidebarLayoutSliding(props: SidebarLayoutProps) {
  let [sidebarVisible, setSidebarVisible] = useState(true);
  function toggleSidebarVisibility() {
    setSidebarVisible(!sidebarVisible);
  }

  let commonStyle = {};
  if (props.verticalProps) {
    commonStyle = {
      overflowY: "scroll",
      overflowX: "hidden",
      height: `calc(100vh - ${props.verticalProps.verticalHeightToMinusPx})`,
    };
  }

  return (
    <div className="row m-0 SidebarLayoutSliding">
      <div
        className={`col-auto border-right px-0 ${!sidebarVisible} ${
          sidebarVisible ? "eb-sidebar-expanded" : "eb-sidebar-collapsed"
        }`}
      >
        <SidebarToggleButton
          sidebarVisible={sidebarVisible}
          onClick={toggleSidebarVisibility}
        />
        {sidebarVisible && (
          <div className="eb-sidebar" style={commonStyle}>
            {props.sidebar}
          </div>
        )}
      </div>
      <div className="col p-0 eb-main-content" style={commonStyle}>
        {props.mainContent}
      </div>
    </div>
  );
}

interface SidebarToggleButtonProps {
  sidebarVisible: boolean;
  onClick: () => void;
}
function SidebarToggleButton(props: SidebarToggleButtonProps) {
  return (
    <div className="eb-sidebar-toggle-button">
      {props.sidebarVisible && (
        <EBButtonV2
          className="btn-sm btn-light rounded-circle border  border-1"
          content={{ normal: <ArrowIcon dir={"left"} /> }}
          onClick={props.onClick}
        />
      )}

      {!props.sidebarVisible && (
        <EBButtonV2
          className="btn-sm btn-light rounded-circle border border-1"
          content={{ normal: <ArrowIcon dir={"right"} /> }}
          onClick={props.onClick}
        />
      )}
    </div>
  );
}
